var root = 'vvqzc70';

export { root };
//# sourceMappingURL=modal-primitive.css.js.map
